import React from 'react'
import { AppImg, AppSvg, FormattedHTMLMessage, icons, Button } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'

import { useIntl } from 'react-intl'
import styles from '../../style.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { images } from '~constants/images'
import useToast from '~hooks/useToast'
import { usePromise } from '~hooks/usePromise'
import { useMigrationStatus, userApi } from '~api'
import { globalLang } from '~globalLang'

interface Props {
    onSuccess: () => void
}

function Confirm({ onSuccess }: Props) {
    const { logout, isLogoutLoading } = useAuth()
    const { mutate } = useMigrationStatus()

    const intl = useIntl()
    const brokerName = intl.formatMessage(globalLang.brokerName)

    const pushToast = useToast({ caption: lang.confirmMigrationError, timeout: 4000 })

    const { send: sendConfirmation, isLoading: isSendConfirmationLoading } = usePromise(
        async () => {
            await userApi.postFinishMigration()
        },
        {
            onSuccess: () => {
                onSuccess()
                mutate(
                    {
                        fw_migration_finish: true,
                        fw_migration_start: true,
                    },
                    { revalidate: false }
                )
            },
            onError: () => pushToast(),
        }
    )

    return (
        <ModalView
            img={
                <div className={styles.imageGroup}>
                    <div className={styles.logoFreewallet}>
                        <AppImg themed imgName={images.logoFreewallet} />
                    </div>
                    <div className={styles.arrowSvg}>
                        <AppSvg size={30} svgName={icons.ic24ArrowRight} />
                    </div>
                    <AppImg size={60} themed imgName={images.logoSquare} />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.confirmMigrationTitle} />}
            subtitle={<FormattedHTMLMessage {...lang.confirmMigrationSubtitle} values={{ brokerName }} />}
        >
            <div className={styles.mainActionButton}>
                <Button
                    size="l"
                    fullWidth
                    mode="primary"
                    onClick={sendConfirmation}
                    dataPointer="confirm_button"
                    isDisabled={isLogoutLoading}
                    isLoading={isSendConfirmationLoading}
                >
                    <FormattedHTMLMessage {...lang.confirmButtonText} />
                </Button>
            </div>
            <Button
                size="l"
                fullWidth
                onClick={() => logout()}
                dataPointer="logout_button"
                isLoading={isLogoutLoading}
                isDisabled={isSendConfirmationLoading}
            >
                <FormattedHTMLMessage {...lang.signOutButtonText} />
            </Button>
        </ModalView>
    )
}

export default Confirm
